var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "7" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.start_date,
                          endDate: _vm.end_date,
                          "locale-data": _vm.locale
                        },
                        on: { update: _vm.updateDate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.refresh }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" " + _vm._s(_vm.$t("search")))
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { sm: "6", lg: "6" } }, [
            _vm.best_sale_data != null
              ? _c(
                  "table",
                  { staticClass: "table" },
                  _vm._l(_vm.best_sale_data, function(item, index) {
                    return _c("tr", [
                      _c("td", [
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            style: "background-color: " + item.color
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { style: "font-weight: 600; color: " + item.color },
                        [_vm._v(_vm._s(item.total))]
                      )
                    ])
                  })
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c("doughnut", {
                attrs: {
                  labels: _vm.best_sale_labels,
                  datasets: _vm.best_sale_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("top_10")))])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a767a27", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a767a27","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductMix.vue
// module id = 1295
// module chunks = 0